import cloneDeep from 'lodash/cloneDeep';
import { getAllTotal } from '@/api/societe/index';

export function InitAgenceRattachement(societesAgences, agenceRattachementId) {
  const societe = societesAgences.find((societe) => {
    const agence = societe.agences.find((agence) => {
      return agence.id === agenceRattachementId;
    });
    if (agence) {
      agence.selected = true;
      agence.disabled = true;
    } return agence;
  });
  if (societe) {
    societe.selected = true;
    societe.disabled = true;
  }
}

function InitAgencesSelected(societesAgences, allIdAgences) {
  societesAgences.forEach((societe) => {
    societe.agences.forEach((agence) => {
      const agenceFind = allIdAgences.find((idAgence) => {
        return agence.id === idAgence;
      });
      if (agenceFind) {
        agence.selected = true;
        societe.selected = true;
      }
    });
  });
}

function madeSocieteAgence(societes) {
  const societesAgence = cloneDeep(societes);
  societesAgence.forEach((societe) => {
    societe.agences.forEach((agence) => {
      agence.selected = false;
      agence.disabled = false;
    });
    societe.selected = false;
    societe.disabled = false;
  });
  return societesAgence;
}

export async function getAllSocietesAgences(agenceRattachementId, allIdAgences) {
  const responseGetAll = await getAllTotal();
  const societesAgences = madeSocieteAgence(responseGetAll.data.result.items);
  InitAgencesSelected(societesAgences, allIdAgences);
  InitAgenceRattachement(societesAgences, agenceRattachementId);
  return societesAgences;
}
